// extracted by mini-css-extract-plugin
export default {"text":"DrawerAccountName_text__wWyXE","button":"DrawerAccountName_button__P9c2s"};